import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import { useSelector, useDispatch } from 'react-redux';
import assetService from "../../../Services/assetService";
import { clearCart } from '../../../Reducers/cartReducer';
import "../Button.css"

const CartDownloadButton = ({ setError, setProgress }) => {
    const dispatch = useDispatch();

    const cartItems = useSelector(state => state.cart.items);
    const channelGuid = useSelector(state => state.channel.channelGuid);

    const onClickDownload = async () => {
        try {
            setProgress(0);
            const success = await assetService.downloadAsset(cartItems, setProgress);
            const itemsIds = cartItems.map((item) => item.globalAssetId);

            if (success) {
                await assetService.updateDownloadCount(channelGuid, itemsIds);
                dispatch(clearCart());
                setProgress(100);
                setProgress(0);
            } else {
                console.error("Download Failed");
                setError(true);
                setProgress(0);
            }
        } catch (error) {
            console.error("Error");
            setError(true);
            setProgress(0);
        }
    }

    return (
        <Dropdown as={ButtonGroup}>
            <Button variant="primary" className='custom-button' onClick={onClickDownload}>
                <i className="bi bi-download"></i>
                <span>  Download</span>
            </Button>
        </Dropdown>
    );
}

export default CartDownloadButton;